import { IFlightPathTheme } from "./types";

export const defaultTheme: IFlightPathTheme = {};
